import * as MHUI from '@marekhealth/mhui';
import styled, { css } from 'styled-components';
import media from 'styled-media-query';
import { lighten } from 'polished';
import { userDragNone, userSelectNone } from '@utils/styles';
import { getFileFromBucket } from '@utils/strings';

export const Papper = styled(MHUI.Papper)`
  ${({ theme }) => css`
    gap: 5rem;
    font-size: ${theme.fonts.sizes.medium};
    min-height: 40rem;
    padding-left: 8vw;
    padding-right: 8vw;
  `}
`;

export const Form = styled.form`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: ${theme.fonts.sizes.xlarge};
    font-family: ${theme.fonts.family.montserrat};
    font-weight: ${theme.fonts.weight.semiBold};
    text-align: center;
    text-transform: uppercase;
  `}
`;

export const MedicalAppointmentImg = styled.img.attrs({
  src: getFileFromBucket('physical_upload_assets/medical-appointment.webp'),
})`
  ${({ theme }) => css`
    border-radius: 50%;
    border: 1rem solid ${lighten(0.1, theme.colors.secondary)};
    border-width: 0px 6px;
    height: 20rem;
    box-shadow: ${lighten(0.46, theme.colors.secondary)} 0px 0px 0px 10px;

    ${userDragNone}
    ${userSelectNone}

    ${media.lessThan('small')`
      height: 18rem;
    `}
  `}
`;

export const DescriptionTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    text-align: center;
    font-weight: ${theme.fonts.weight.semiBold};
  `}
`;

export const DescriptionSubtitle = styled.p`
  ${({ theme }) => css`
    font-weight: ${theme.fonts.weight.semiBold};

    ${media.greaterThan('large')`
      text-align: center;
    `}
  `}
`;

export const FormDescription = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.fonts.sizes.small};
    color: ${lighten(0.2, theme.colors.primary)};
    line-height: 1.4;

    ${media.greaterThan('large')`
      text-align: center;
    `}
  `}
`;

export const Description = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 63rem;

  li {
    list-style-position: inside;
    list-style-type: disc;
    margin-left: 1rem;
  }
`;

export const FieldsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    justify-content: space-between;
    background-color: inherit;
    position: relative;

    label {
      margin-bottom: ${theme.spacings.medium};
      width: 100%;

      ${media.greaterThan('large')`
        flex-basis: 46%;
      `}
    }
  `}
`;
